export default "__VITE_ASSET__1ae3f7c0__"